import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Jul 08 2019
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { observer } from 'mobx-react';
import rootStore from '../../../../../shared/stores/RootStore';
import { StoreName } from '../../../../../shared/stores/StoreName';
import AbstractPromoTooltip from './AbstractPromoTooltip';

var ReleasePromoTooltip =
/*#__PURE__*/
function (_AbstractPromoTooltip) {
  _inherits(ReleasePromoTooltip, _AbstractPromoTooltip);

  function ReleasePromoTooltip() {
    var _this;

    _classCallCheck(this, ReleasePromoTooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleasePromoTooltip).apply(this, arguments));
    _this.releaseStore = rootStore.getStore(StoreName.Release);

    _this.getPromos = function () {
      var releaseItemId = _this.row.data.ReleaseDetailCategory_id;

      var zoneId = _this.props.column.colId.split('_')[1];

      return _this.releaseStore.getPromos(releaseItemId, zoneId);
    };

    return _this;
  }

  return ReleasePromoTooltip;
}(AbstractPromoTooltip);

ReleasePromoTooltip = __decorate([observer], ReleasePromoTooltip);
export default ReleasePromoTooltip;